import { YOUTUBE_IFRAME_API_URL } from '../data/constants';

/**
 * Resolve once the IFrame API is ready, chaining onto any existing callback
 * so two mounts cannot clobber each other. The API fires it exactly once.
 */
export const ytReady = (fn) => {
  if (window.YT && window.YT.Player) {
    fn();
    return;
  }
  if (!document.querySelector(`script[src="${YOUTUBE_IFRAME_API_URL}"]`)) {
    const tag = document.createElement('script');
    tag.src = YOUTUBE_IFRAME_API_URL;
    tag.async = true;
    document.head.appendChild(tag);
  }
  const prev = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = () => {
    if (prev) prev();
    fn();
  };
};

// Embeds are only authorised when the page has a real origin. On file:// we
// send nothing and let YouTube fail loudly rather than silently (error 153).
export const ytOrigin = () =>
  /^https?:$/.test(window.location.protocol)
    ? { origin: window.location.origin, enablejsapi: 1 }
    : {};
